import { Box, Container, Image, Stack, Text } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import { GoBook } from "react-icons/go";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { getAllSubjectsRequest } from "../../../modules/admin-modules/subjects/Actions";
import { useDispatch, useSelector } from "react-redux";

const Services = ({ t }) => {
  const dispatch = useDispatch();
  const subjects = useSelector((state) => state.subjects.subjects);
  useEffect(() => {
    dispatch(getAllSubjectsRequest());
  }, []);

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, name: data.name, logo: data.logo, nameAr: data.nameAr };
  });

  // filter duplicates logos
  const filteredSubjects = subjectsOptions?.filter((elem, index, self) =>
    index === self.findIndex((t) => (t.logo && t.logo === elem.logo))
  );

  
  const baseUrl = "https://api.asquera.com/";

  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: false,
    swipeToSlide: true,
    touchMove: true,
    draggable: true,
    fade: false,
    variableWidth: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          speed: 2000,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          speed: 2000,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: "linear",
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          speed: 2000,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: "linear",
          arrows: false,
        },
      },
    ],
  };
  const sliderRef = useRef();
  return (
    <Box bg="gray.50" w="100%" fontFamily="'Lato', sans-serif">
      <Container
        maxW={"container.xl"}
        my={16}
        id="teachers"
        position="relative"
        pt={12}
        pb={8}
      >
        <Text
          textAlign="center"
          fontWeight="500"
          fontSize={{ base: "20px", md: "25px" }}
          mb={3}
          fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', 'Lato', sans-serif"
          // className="title-line"
        >
          {t("components.services.title")}{" "}
          <Image src={require("../../../assets/line.jpg")} m="auto" mt={3} />
        </Text>

        <Slider {...settings} ref={sliderRef}>
          {filteredSubjects?.map((elem, index) => {
            return (
              <Box
                key={index}
                bg="white"
                borderRadius="24px"
                h="400px"
                p="0"
                w={{ base: "90% !important", md: "350px" }}
                boxShadow="0 10px 30px rgba(0,0,0,0.1)"
                border="1px solid"
                borderColor="gray.100"
                overflow="hidden"
                transition="all 0.3s ease"
                _hover={{
                  transform: "translateY(-8px)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                  borderColor: "blue.200"
                }}
                position="relative"
                group
                display="flex"
                flexDirection="column"
              >
                <Box position="relative" overflow="hidden" flex="1">
                  <Image
                    borderRadius="0"
                    src={elem?.logo ? baseUrl + elem?.logo : "/logo.png"}
                    height="280px"
                    width="100%"
                    objectFit="cover"
                    objectPosition="top"
                    color="transparent"
                    transition="transform 0.3s ease"
                    _groupHover={{
                      transform: "scale(1.05)"
                    }}
                  />
                  <Box
                    position="absolute"
                    top="0"
                    left="0"
                    right="0"
                    bottom="0"
                    bgGradient="linear(to-b, transparent 0%, rgba(0,0,0,0.1) 100%)"
                  />
                </Box>
                
                <Stack justify="space-between" p={6} spacing={4} flex="1">
                  <Stack direction="row" alignItems="center" spacing={3}>
                    <Box
                      p={2}
                      bg="blue.50"
                      borderRadius="full"
                      color="blue.500"
                    >
                      <GoBook fontSize="18px" />
                    </Box>
                    <Text fontSize="16px" fontWeight="600" color="gray.700" fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', 'Lato', sans-serif">
                      {elem?.name}
                    </Text>
                  </Stack>
                  
                  <Text fontSize="20px" fontWeight="700" color="gray.800" fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', 'Lato', sans-serif">
                    {elem?.nameAr}
                  </Text>
                </Stack>
              </Box>
            );
          })}
        </Slider>
      </Container>
    </Box>
  );
};

export default withTranslation()(Services);
